import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { senaRefreshToken } from '../../api/senaApi';
import './SenaMain.css';

const CATEGORIES = [
  { id: 'siege',      label: '공성전',       icon: '🏰', desc: '공성전 공략 및 편성' },
  { id: 'guild-war',      label: '길드전(공격)', icon: '⚔️', desc: '적군 덱별 카운터 공략' },
  { id: 'guild-war-def',  label: '길드전(방어)', icon: '🛡️', desc: '방어 덱 세팅 공유' },
  { id: 'total-war',  label: '총력전',       icon: '🔥', desc: '총력전 공략 및 점수' },
  { id: 'expedition', label: '강림원정대',   icon: '🗺️', desc: '강림원정대 편성 가이드' },
  { id: 'raid',       label: '레이드(일반)', icon: '🐉', desc: '일반 레이드 공략' },
  { id: 'raid-sp',    label: '레이드(돌발)', icon: '⚡', desc: '돌발 레이드 공략' },
];

export default function SenaMain() {
  const navigate = useNavigate();

  // 접속 시 토큰 자동 갱신 (7일 연장)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      senaRefreshToken().then(res => {
        const { token: newToken, userId, userName, userRole } = res.data;
        localStorage.setItem('token', newToken);
        localStorage.setItem('userId', userId);
        localStorage.setItem('userName', userName);
        localStorage.setItem('userRole', userRole);
      }).catch(() => {
        // 토큰 만료/무효 → 정리
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('userRole');
      });
    }
  }, []);

  return (
    <div className="sena-page">
      {/* Header */}
      <header className="sena-header">
        <h1 className="sena-header-guild">세나리 추력 길드</h1>
        <p className="sena-header-sub">공략 페이지</p>
        <span className="sena-header-credit">(made by 헬스)</span>
      </header>

      {/* Body */}
      <div className="sena-body">
        {/* Left: 개인정보 */}
        <aside className="sena-sidebar">
          <div className="sena-profile-card">
            {localStorage.getItem('token') ? (
              <>
                <div className="sena-profile-info">
                  <p className="sena-profile-label">닉네임</p>
                  <p className="sena-profile-value">{localStorage.getItem('userName') || localStorage.getItem('userId')}</p>
                </div>
                <div className="sena-profile-info">
                  <p className="sena-profile-label">등급</p>
                  <p className="sena-profile-value">{localStorage.getItem('userRole') || '-'}</p>
                </div>
                <button className="sena-profile-btn" onClick={() => navigate('/sena/profile')}>
                  내정보 수정
                </button>
                <button className="sena-profile-btn" onClick={() => navigate('/sena/coupon')}>
                  쿠폰 일괄등록
                </button>
                {['ADMIN', 'MASTER'].includes(localStorage.getItem('userRole')) && (
                  <button className="sena-profile-btn" onClick={() => navigate('/sena/admin')}>
                    회원관리
                  </button>
                )}
                {(localStorage.getItem('userRole') === 'ADMIN') && (
                  <button className="sena-profile-btn" onClick={() => navigate('/sena/admin/hero')}>
                    영웅 등록
                  </button>
                )}
                <button className="sena-profile-btn" onClick={() => {
                  localStorage.removeItem('token');
                  localStorage.removeItem('userId');
                  localStorage.removeItem('userName');
                  localStorage.removeItem('userRole');
                  window.location.reload();
                }}>
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <div className="sena-profile-info">
                  <p className="sena-profile-label">닉네임</p>
                  <p className="sena-profile-value">게스트</p>
                </div>
                <button className="sena-profile-btn" onClick={() => navigate('/sena/login')}>
                  로그인
                </button>
              </>
            )}
          </div>
        </aside>

        {/* Right: 카테고리 */}
        <main className="sena-content">
          <div className="sena-category-grid">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                className="sena-category-card"
                onClick={() => navigate(`/sena/${cat.id}`)}
              >
                <span className="sena-category-icon">{cat.icon}</span>
                <strong className="sena-category-label">{cat.label}</strong>
                <span className="sena-category-desc">{cat.desc}</span>
              </button>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
